<template>
  <va-page-layout
    :minimized.sync="minimized"
    :mobileWidth="mobileWidth"
  >
    <app-navbar
      :minimized.sync="minimized"
    />
    <app-sidebar
      :minimized.sync="minimized"
    />
    <main
      slot="content"
      id="content"
      class="layout gutter--xl fluid"
      :class="{'app-layout__main--full-width-sidebar': !minimized}"
      role="main">

      <MinimizedCall
        v-if="!isLoading && !hasVirtualWaitingRoomService"
        v-for="(service, index) in authClinicalServices"
        :key="index"
        :authClinicalService="service"
      />

      <VirtualWaitingRoomMinimizedCall
        v-if="!isLoading && hasVirtualWaitingRoomService"
      />



      <router-view :key="$route.fullPath" />

    </main>
    <app-footer slot="footer"></app-footer>
  </va-page-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import VaPageLayout from './VaPageLayout'
import AppFooter from './app-footer/AppFooter'
import AppNavbar from './app-navbar/AppNavbar'
import AppSidebar from './app-sidebar/AppSidebar'
import MinimizedCall from '@/components/clinical/calls/MinimizedCall'
import VirtualWaitingRoomMinimizedCall from '@/components/virtual_waiting_room/waiting_room/MinimizedCall'

export default {
  name: 'app-layout',
  components: {
    VaPageLayout,
    AppNavbar,
    AppSidebar,
    AppFooter,
    MinimizedCall,
    VirtualWaitingRoomMinimizedCall
  },
  data () {
    return {
      minimized: false,
      mobileWidth: 767,
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'sidebarMinimized',
      'authClinicalServices'
    ]),
    hasVirtualWaitingRoomService: function() {
      return this.$store.state.services.some(s => s.url === this.$store.state.virtual_waiting_room_server)
    }
  },
  methods: {
    toggleSidebar: function (minimized) {
      this.minimized = minimized
      this.$store.dispatch('toggleSidebar', minimized)
    }
  },
  watch: {
    sidebarMinimized: {
      handler: function (value) {
        this.minimized = value
      },
      immediate: true
    },
    minimized: function (value) {
      this.toggleSidebar(value)
    }
  }
}
</script>

<style lang="scss">
  .footerText {
    font-size: 0.8rem;
  }
  .app-layout {
    &__main {
      &--full-width-sidebar {
        @include media-breakpoint-down(xs) {
          display: none;
        }
      }
    }
  }
</style>
